import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Site } from '@swf/core/enums';
import { select } from '@swf/core/store';

import styles from './useStickyTopHeaderClassName.scss';

const siteStyle = {
  [Site.DK]: 'Dk',
  [Site.SE]: 'Se'
};

const useStickyTopHeaderClassName = (variant?: 'header' | 'sports' | 'casino') => {
  const site = useSelector(select.site.getId);
  const isStickyTopHeader = [Site.SE, Site.DK].includes(site);
  const isDownloadBannerVisible = useSelector(select.notification.showDownloadBanner);

  useEffect(() => {
    const withDownloadBanner = () => {
      if (!isStickyTopHeader) {
        return;
      }

      const appDownloadBanner = document.getElementById('app-download-banner');
      const stickyTopHeader = document.getElementById('sticky-top-container');

      if (!isDownloadBannerVisible && stickyTopHeader) {
        stickyTopHeader.style.top = '0';
        window.removeEventListener('scroll', withDownloadBanner);
      }

      if (appDownloadBanner && stickyTopHeader) {
        const { bottom } = appDownloadBanner.getBoundingClientRect();
        if (bottom > 0) {
          stickyTopHeader.style.top = `${bottom}px`;
        } else {
          stickyTopHeader.style.top = '0';
        }
      }
    };

    withDownloadBanner();
    window.addEventListener('scroll', withDownloadBanner);
    return () => window.removeEventListener('scroll', withDownloadBanner);
  }, [isDownloadBannerVisible, isStickyTopHeader]);

  if (!isStickyTopHeader || !variant) {
    return;
  }

  return styles[`${variant}${siteStyle[site]}TopSticky`];
};

export default useStickyTopHeaderClassName;
